import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { escape, reduce, isString, isObject } from 'lodash';

import { sanitize } from 'utils/dompurify';

import * as styled from './styles';

export const toFormattedText = (text, type) => {
  switch (type) {
    case 'color':
      return text.replace(/\*\*(.*?)\*\*/g, '<span>$1</span>');
    case 'bold':
      return text.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
    case 'underline':
      return text.replace(/__(.*?)__/g, '<u>$1</u>');
    case 'code':
      return text.replace(/`(.*?)`/g, '<mark>$1</mark>');
    case 'mixed':
      return reduce(
        ['color', 'bold', 'underline', 'code'],
        (acc, t) => toFormattedText(acc, t),
        text
      );
    default:
      return text;
  }
};

/* eslint react/no-danger: 0 */
const HighlightComponent = function Highlight(props) {
  const { intl, className, type, text, values } = props;
  let html = '';
  if (isObject(text)) {
    html = intl.formatMessage(text, values);
  } else if (isString(text)) {
    html = text;
  }
  html = toFormattedText(escape(html), type);

  return (
    <styled.Highlight
      className={className}
      dangerouslySetInnerHTML={{
        __html: sanitize(html),
      }}
    />
  );
};

HighlightComponent.propTypes = {
  intl: PropTypes.object,
  className: PropTypes.string,
  type: PropTypes.oneOf(['mixed', 'color', 'underline', 'bold', 'code']),
  text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  values: PropTypes.object,
};

HighlightComponent.defaultProps = {
  type: 'color',
  values: {},
};

export const Highlight = injectIntl(HighlightComponent);
